import React, { useContext, useState } from "react";
import BreakpointContext from "../../contexts/breakpointContext";
import useDraftChat from "../../hooks/queryResults/draft/useDraftChat";
import classNames from "classnames";
import styled from "styled-components";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTeams from "../../hooks/queryResults/useTeams";
import Loading from "../ui/Loading";
import TeamLogoWithRosterLink from "./TeamLogoWithRosterLink";

const StyledContainerDiv = styled.div`
  width: 100%;
  height: ${(props) => props.height};
  overflow-y: scroll;
`;

const StyledInput = styled.input`
  width: 97%;
  max-width: 100%;
  margin: 0 0 0.5rem;
  font-size: 0.75rem;
  padding: 0.5rem;
  border: 2px solid #0078f8;
  border-radius: 0.5rem;
`;

const StyledMessageDiv = styled.div`
  padding: 0.25rem;
  width: 97%;
  margin-bottom: 0.25rem;

  &.is-official {
    background: #e6f2ff;
  }
`;

// const color = "#e6f7ff"

export default function Chat() {
  const breakpoints = useContext(BreakpointContext);
  const { messages, sendMessage } = useDraftChat();
  const [newMessage, setNewMessage] = useState("");
  const { teams, teamsQuery } = useTeams();

  const isLoading = useIsLoading(teams, teamsQuery);
  if (isLoading) return <Loading />;

  const handleNewMessageChange = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      sendMessage(newMessage);
      setNewMessage("");
    }
  };

  const height = breakpoints.md ? "40rem" : breakpoints.sm ? "15rem" : "20rem";

  return (
    <StyledContainerDiv height={height}>
      <StyledInput
        type={"text"}
        placeholder={"Add chat message..."}
        onKeyUp={handleNewMessageChange}
        onChange={(event) => setNewMessage(event.target.value)}
        value={newMessage}
      />
      {[...messages].reverse().map((message, i) => {
        const classNamesObj = {};
        // noinspection JSIncompatibleTypesComparison
        classNamesObj["is-official"] = message.messageType === 3;

        let content = message.content;
        if (content.indexOf("\n") !== -1) {
          const [part1, part2] = content.split("\n");
          content = (
            <>
              {part1}
              <br />
              <span style={{ paddingLeft: "0.5rem" }}>{part2}</span>
            </>
          );
        }

        let show = content;

        if (message.messageType === 4 && message.fromType === "Team") {
          const teamId = message.fromObj;
          const team = teams.getTeamById(teamId, false);
          const teamLogo = <TeamLogoWithRosterLink team={team} size={"sm"} />;
          show = (
            <div style={{ display: "flex", alignItems: "center" }}>
              {teamLogo}
              <span>{content}</span>
            </div>
          );
        }

        return (
          <StyledMessageDiv key={i} className={classNames(classNamesObj)}>
            {show}
          </StyledMessageDiv>
        );
      })}
    </StyledContainerDiv>
  );
}
